import React from "react";
import { Toast } from "./Toast";

export interface ToastData {
  id: string;
  message: string;
  secondMessage?: string;
  type: "success" | "error" | "warning" | "info" | "deleted";
  linkId?: string;
  linkName?: string;
}

export interface GlobalToastManagerProps {
  toasts: ToastData[];
  onRemoveToast: (id: string) => void;
  onLinkClick?: (linkId: string) => void;
}

const GlobalToastManager: React.FC<GlobalToastManagerProps> = ({
  toasts,
  onRemoveToast,
  onLinkClick,
}) => {
  return (
    <div style={{ position: "fixed", top: 70, right: 20, zIndex: 9999 }}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          secondMessage={toast.secondMessage}
          type={toast.type}
          linkId={toast.linkId}
          linkName={toast.linkName}
          onClose={() => onRemoveToast(toast.id)}
          onLinkClick={onLinkClick}
        />
      ))}
    </div>
  );
};

export default GlobalToastManager;
